import React from 'react';
import {FastField, Field} from 'formik';
import {Grid} from '@material-ui/core';
import {MDBPopover, MDBPopoverBody} from 'mdbreact';
import FormikDateSelector from 'gui/components/formikDateSelector/FormikDateSelector';
import RoomMealSelector from './components/roomMealSelector/RoomMealSelector';
import {FormikErrors} from 'formik/dist/types';
import {IOfferDetailsProps, IPlaceDetails, IPredictionFormatted} from 'data/interfaces/products';
import {syncDates} from '../../../../../commons/editor/utils';
import FormikPlusMinusInput from 'gui/components/formikPlusMinusInput';
//import vacationTypeSelector from '../../../../../commons/editor/components/vacationTypeSelector';
import EditorSection from '../../../../../commons/editor/components/editorSection';
import {getDatePlusDays} from 'data/utils/calculators';

//import {Unless} from 'react-if';


/**
 *    <Unless condition={true}>
 {() => <MDBPopover
          placement="top"
          popover
          clickable
          domElement={true}
        >
          <div>
            <FastField
              component={vacationTypeSelector}
              label="סוג חופשה * "
              name="vacationType"
              noBorder
            />
          </div>
          <div>
            <MDBPopoverBody>
              הסוג של החופשה שתוכננה עם הטיסה
            </MDBPopoverBody>
          </div>
        </MDBPopover>}
 </Unless>
 */

export interface IHotel extends IPredictionFormatted, IPlaceDetails {
  postalCode: string;
}

const OfferDetails = (props: { values: IOfferDetailsProps, submitCount: number, errors: FormikErrors<any>, setFieldValue: any }) => (
  <EditorSection title="פרטי הצעה">
    <Grid item xs={12} sm={6}>
      <Field
        component={FormikDateSelector}
        label="תאריך כניסה"
        name="checkInDate"
        minDate={getDatePlusDays(1)}
        handleChange={(value) => syncDates(props, 'checkInDate', getDatePlusDays(1, value))}
        noBorder
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <Field
        component={FormikDateSelector}
        label="תאריך יציאה"
        name="checkOutDate"
        minDate={props.values.checkInDate ? getDatePlusDays(1, new Date(props.values.checkInDate)) : getDatePlusDays(1)}
        handleChange={(value) => syncDates(props, 'checkOutDate', value)}
        noBorder
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <MDBPopover
        placement="top"
        popover
        clickable
        domElement={true}
      >
        <div>
          <FastField
            component={FormikPlusMinusInput}
            label="מספר חדרים *"
            name="roomsAmount"/>
        </div>
        <div>
          <MDBPopoverBody>
            כמה חדרים סך הכל
          </MDBPopoverBody>
        </div>
      </MDBPopover>
    </Grid>

    <Grid item xs={12} sm={6}>
      <MDBPopover
        placement="top"
        popover
        clickable
        domElement={true}
      >

        <div>
          <FastField
            component={FormikPlusMinusInput}
            label="מספר אנשים *"
            name="roomPeopleAmount"/>
        </div>
        <div>
          <MDBPopoverBody>
            כמה אנשים סך הכל
          </MDBPopoverBody>
        </div>
      </MDBPopover>
    </Grid>

    <Grid item xs={12} sm={6}>
      <MDBPopover
        placement="top"
        popover
        clickable
        domElement={true}
      >
        <div>
          <FastField
            component={RoomMealSelector}
            label="ארוחות *"
            name="roomMeal"
            noBorder
          />
        </div>
        <div>
          <MDBPopoverBody>
            ארוחות שכלולות בהזמנת המלון
          </MDBPopoverBody>
        </div>
      </MDBPopover>
    </Grid>

    <Grid item xs={12} sm={6}>

    </Grid>
  </EditorSection>
);

OfferDetails.defaultProps = {
  values: {},
  errors: [],
  submitCount: 0,
  setFieldValue: () => null,
};

export default React.memo(OfferDetails);
